import { NEGLIGIBLE_SENTRY_CAPTURE_ERROR_TYPES, NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES } from '../constants.mjs';
import { decideError } from './apiError.mjs';
import { isAxiosError } from './axiosError.mjs';
import { isRouteChangeCanceledError } from './customError.mjs';

function isNegligibleSentryCapture(error) {
  if (isAxiosError(error)) {
    const [errorType, httpError] = decideError(error);
    if (error.code === "ECONNABORTED") {
      return true;
    }
    if (NEGLIGIBLE_SENTRY_CAPTURE_ERROR_TYPES.includes(errorType)) {
      return true;
    }
    const code = httpError?.code;
    if (typeof code === "string" && NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES.includes(code)) {
      return true;
    }
    return false;
  }
  if (isRouteChangeCanceledError(error)) {
    return true;
  }
  return false;
}

export { isNegligibleSentryCapture };
//# sourceMappingURL=sentry.mjs.map
